<template>
  <div class="item segment" :class="{collapsed: collapsed, deletewarn: showDeleteConfirm, loading: loading}">
    <ValidationObserver v-slot="{ dirty, invalid }" ref="observer">
    <div class="header" @click="collapsed = !collapsed">
      <b>Segment</b> [ id: {{structure.id ? structure.id : '--'}} ] 
      <span class="toggle">&lt;</span> 
      <span v-if="invalid" class="invalid">⚠</span>
      <span v-if="!editorStructure.id || dirty" class="unsaved">Unsaved Changes</span> 
      <span class="label">{{structure.txt1}}</span> 
      <button class="insead white autowidth icon loader" v-show="!showSaveConfirm" :class="{dirty: dirty}" :disabled="loading || parentLoading" @click.stop="save">
        <img v-if="!loading" src="/save.png">
        <img v-else src="/spinner.svg">
      </button>
      <button class="insead white autowidth icon" v-show="showSaveConfirm" :disabled="loading || parentLoading" @click.stop="showSaveConfirm = false">Cancel</button>
      <button class="insead white autowidth icon" v-show="showSaveConfirm" :disabled="loading || parentLoading" @click.stop="save">Yes, save <i>invalid</i> item</button>
      <button class="insead white autowidth icon" v-show="!showDeleteConfirm" :disabled="loading || parentLoading" @click.stop="showDeleteConfirm = true"><img src="/delete.png"></button>
      <button class="insead white autowidth icon" v-show="showDeleteConfirm" :disabled="loading || parentLoading" @click.stop="showDeleteConfirm = false">Cancel</button>
      <button class="insead white autowidth icon" v-show="showDeleteConfirm" :disabled="loading || parentLoading" @click.stop="$emit('remove'); showDeleteConfirm = false;">Yes, confirm</button>
      <button class="insead white autowidth icon" @click.stop="$emit('up');" :disabled="loading || parentLoading" title="Move up"><img src="/triangle.png"></button>
      <button class="insead white autowidth icon" @click.stop="$emit('down');" :disabled="loading || parentLoading" title="Move down"><img style="transform: rotate(180deg);" src="/triangle.png"></button>
    </div>
    <table v-show="!collapsed">
      <!-- <tr><td>id:</td><td colspan="2"> <input type="number" v-model.number="structure.id"></td></tr> -->
      <tr class="inputrow">
        <td><strike>seg:</strike></td><td colspan="2">
        <ValidationProvider name="seg" v-slot="{ classes, errors }">
          <input type="text" v-model.trim="structure.seg" :disabled="loading || parentLoading || showSaveConfirm" :class="classes">
          <span class="errormessage">{{ errors[0] }}</span>
        </ValidationProvider>
      </td></tr>
      <tr class="inputrow">
        <td>txt1:</td>
        <td colspan="2"> 
          <ValidationProvider name="txt1" v-slot="{ classes, errors }">
            <input type="text" required v-model.trim="structure.txt1" :disabled="loading || parentLoading || showSaveConfirm" :class="classes">
            <span class="errormessage">{{ errors[0] }}</span>
          </ValidationProvider>
        </td>
      </tr>
      <tr class="inputrow">
        <td>txt2:</td>
        <td colspan="2">
          <ValidationProvider name="txt2" v-slot="{ classes, errors }">
            <input type="text" v-model.trim="structure.txt2" :disabled="loading || parentLoading || showSaveConfirm" :class="classes">
            <span class="errormessage">{{ errors[0] }}</span>
          </ValidationProvider>
        </td>
      </tr>
      <tr class="inputrow">
        <td>hotspotsLabelName:</td>
        <td colspan="2"> 
          <ValidationProvider name="hotspotsLabelName" v-slot="{ classes, errors }">
            <input type="text" :disabled="loading || parentLoading || showSaveConfirm" :class="classes" v-model.trim="structure.hotspotsLabelName" placeholder="default name on dashboard is 'scene'">
            <span class="errormessage">{{ errors[0] }}</span>
          </ValidationProvider>
        </td></tr>
      <tr class="inputrow">
        <td>icon:</td>
        <td> 
          <ValidationProvider name="icon" rules="imageUrl" v-slot="{ classes, errors }">
            <input type="text" v-model.trim="structure.icon" :disabled="loading || parentLoading || showSaveConfirm" :class="classes" placeholder="image path relative to webContentRootPath">
            <span class="errormessage">{{ errors[0] }}</span>
          </ValidationProvider>
        </td>
        <td v-if="structure.icon" class="preview" rowspan="3"><img :src="`${blobRoot}${$store.state.editorWebContentRootPath}${structure.icon}`"></td>
      </tr>
      <tr class="inputrow">
        <td>stereo:</td>
        <td> 
          <ValidationProvider name="stereo" v-slot="{ classes, errors }">
            <input type="checkbox" :disabled="loading || parentLoading || showSaveConfirm" :class="classes" v-model="structure.segJson.stereo">
            <span class="errormessage">{{ errors[0] }}</span>
          </ValidationProvider>
        </td>
      </tr>
      <tr class="inputrow">
        <td>type:</td>
        <td> 
          <ValidationProvider name="type" v-slot="{ classes, errors }">
            <input type="text" :disabled="loading || parentLoading || showSaveConfirm" :class="classes" v-model="structure.segJson.type" style="width: 200px;"> (TODO what is 'graph' compared to 'seg' in a segment?... sometimes not even defined at all. ask Arik what's this for if it has any meaning at all)
            <span class="errormessage">{{ errors[0] }}</span>
          </ValidationProvider>
        </td>
      </tr>
      <tr v-if="isConditional" class="inputrow">
        <td>condition:</td>
        <td colspan="2"> 
          <ValidationProvider name="condition" v-slot="{ classes, errors }">
            <input type="text" :disabled="loading || parentLoading || showSaveConfirm" :class="classes" placeholder="short condition label text, like A,B,C... or similar." v-model.trim="structure.condition">
            <span class="errormessage">{{ errors[0] }}</span>
          </ValidationProvider>
        </td>
      </tr>
      <tr>
        <td>items:</td>
        <td class="expandbuttons">
          <button class="insead white autowidth icon" @click="collapseAll" title="Collapse all items"><img src="/collapse.png"></button>
          <button class="insead white autowidth icon" @click="expandAll" title="Expand all items"><img src="/expand.png"></button>
        </td>
      </tr>
    </table>
    </ValidationObserver>  
    <div class="children" v-show="!collapsed">
      <div class="label" v-if="structure.segJson.items && structure.segJson.items.length">
        <span v-if="$refs.observer.flags.dirty || $refs.observer.flags.invalid" :class="{dirty: $refs.observer.flags.dirty, invalid: $refs.observer.flags.invalid}">⚠</span>
        <div>Segment: {{structure.id}} - <span>{{structure.txt1}}</span></div>
      </div>
      <div class="items">
        <div class="insertactions" v-if="structure.id">
          <img width="16" height="16" src="/plus.png" />
          <div style="width: 325px;">
            <button class="insead autowidth white" @click="addItem(0, 'pic')" >Image</button>
            <button class="insead autowidth white" @click="addItem(0, 'vid')" >Video</button>
            <button class="insead autowidth white" @click="addItem(0, 'txt')" >Text</button>
            <button class="insead autowidth white" @click="addItem(0, 'question')" >Question</button>
            <button class="insead autowidth white" @click="addItem(0, 'hotspot')" >Hotspot</button>
          </div>
        </div> 
        <div style="color: #a0a0a0;" v-else>Note: newly added segment must be saved before child items can be added.</div>
        <template v-for="(item, index) in structure.segJson.items" >
          <component v-if="itemType(item.structure)" :key="item.editorId"
            ref="items"
            :is="itemType(item.structure)"
            :editorStructure="item"
            :parentLoading="loading || parentLoading"
            @remove="removeItem(index)"
            @up="moveUp(index)"
            @down="moveDown(index)"
          /> 
          <div class="insertactions" v-if="itemType(item.structure)" :key="generateEditorId() +'actions_' + index">
            <img width="16" height="16" src="/plus.png" />
            <div style="width: 325px;">
              <button class="insead autowidth white" @click="addItem(index+1, 'pic')" >Image</button>
              <button class="insead autowidth white" @click="addItem(index+1, 'vid')" >Video</button>
              <button class="insead autowidth white" @click="addItem(index+1, 'txt')" >Text</button>
              <button class="insead autowidth white" @click="addItem(index+1, 'question')" >Question</button>
              <button class="insead autowidth white" @click="addItem(index+1, 'hotspot')" >Hotspot</button>
            </div>
          </div>          
        </template>
      </div>
    </div>    
    <Snackbar ref="snackbar" /> 
  </div>
</template>


<script>
// eslint-disable-next-line
import {getContentComponentType, getEmptyContent, generateEditorId, validateS3Files} from '@/utils.js'
import VideoItem from '@/components/content/Video.vue'
import PictureItem from '@/components/content/Picture.vue'
import TextItem from '@/components/content/Text.vue'
import QuestionItem from '@/components/content/Question.vue'
import Hotspot from '@/components/content/Hotspot.vue'
import _ from 'lodash'
import axios from 'axios'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import '@/veevalidate.js'
import Snackbar from '@/components/Snackbar.vue'
import Vue from 'vue'

export default {
  name: 'SegmentItem',
  components: {
    VideoItem,
    PictureItem,
    TextItem,
    QuestionItem,
    Hotspot,
    ValidationProvider,
    ValidationObserver,
    Snackbar
  },
  props: {
    editorStructure: Object,
    isConditional: Boolean,
    parentLoading: Boolean
  },
  data: function() {
    return {
      blobRoot: process.env.VUE_APP_PUBLIC_BLOB,
      showDeleteConfirm: false,
      showSaveConfirm: false,
      collapsed: false,
      loading: false,
      fileFields: ['icon'],
      structure: {
        type: "seg",
        id: undefined,
        seg: undefined,
        txt1: undefined,
        txt2: undefined,
        hotspotsLabelName: undefined,
        icon: undefined,
        segJson:{
          stereo: true,
          type: 'seg',
          items: []
        },
        condition: undefined
      }
    }
  },
  computed: {
    // dirtyy(){
    //   return this.$refs.observer?.flags.dirty || (this.$refs.items?.findIndex(item => item.$refs.observer?.flags.dirty ) >= 0)
    // },
    // invalid(){
    //   return this.$refs.observer?.flags.invalid || (this.$refs.items?.findIndex(item => item.$refs.observer?.flags.invalid ) >= 0)
    // }
  },
  methods: {   
    generateEditorId(){
      return generateEditorId()
    },   
    addItem(index, type){ 
      let newItem = {
        editorId: generateEditorId(),
        parentId: Number(this.editorStructure.id),
        order: index,
        structure: getEmptyContent(type)
      }
      this.structure.segJson.items.splice(index, 0, newItem)      
      for (let i = 0; i < this.structure.segJson.items.length; i++) {
        this.structure.segJson.items[i].order = i          
      } 
    }, 
    itemType(item){
      return getContentComponentType(item)
    },
    async generate(saveDraft){
      let tmp = _.cloneDeep(this.structure)
      const childNodes = this.$refs.items ? this.$refs.items.map(i => i.generate(saveDraft)) : []
      tmp.segJson.items = childNodes.map(n => n.json)  

      const ret = {json: tmp, fileList: (this.editorStructure.fileList ?? []).concat(childNodes.flatMap(f => f.fileList))}

      if(saveDraft)
        await axios.post(`content/${this.editorStructure.id}/draft`, {structure: JSON.stringify(tmp), fileList: ret.fileList})

      return ret
    },
    collapse(){
      this.collapsed = true
    },
    expand(){
      this.collapsed = false
    },
    collapseAll(){
      this.$refs.items?.forEach(child => {
        child.collapse()
      })
    },
    expandAll(){
      this.$refs.items?.forEach(child => {
        child.expand()
      })
    },
    async removeItem(index){
      if(this.structure.segJson.items[index].id)
        await axios({ url: `content/${this.structure.segJson.items[index].id}`, method: "DELETE" })
      this.structure.segJson.items.splice(index, 1)
    },
    moveDown(index){      
      if(index < (this.structure.segJson.items.length + 1)){
        this.structure.segJson.items.move(index, index + 1)
        for (let i = 0; i < this.structure.segJson.items.length; i++) {
          this.structure.segJson.items[i].order = i          
        }
      }
    },
    moveUp(index){      
      if(index > 0){
        this.structure.segJson.items.move(index, index - 1)
        for (let i = 0; i < this.structure.segJson.items.length; i++) {
          this.structure.segJson.items[i].order = i          
        }
      }
    },
    async save(){
      await this.$refs.observer.validate()
      // this.$refs.items?.forEach(item => {
      //   item.$refs.observer.validate()
      // })

      if((!await validateS3Files(this) || this.$refs.observer?.flags.invalid) && !this.showSaveConfirm){
        this.showSaveConfirm = true
        return
      }

      try{
        this.loading = true
        // eslint-disable-next-line
        const {segJson, ...temp} = this.structure    
        // eslint-disable-next-line    
        const {items, ...temp2} = this.structure.segJson
        temp.id = this.editorStructure.id
        temp.segJson = temp2
        let resp = await axios({ url: `content/segment${this.structure.id ? ('/'+this.structure.id) : ''}`, data: ({
          structure: JSON.stringify(/*this.generate()*/temp), 
          fileList: this.editorStructure.fileList,
          parentId: this.editorStructure.parentId,
          order: this.editorStructure.order}), method: "POST" })
        this.editorStructure.id = this.structure.id = resp.data.id // update for newly created
        this.$refs.observer.reset()
        await this.$refs.observer.validate()
        // this.$refs.items?.forEach(item => {
        //   item.$refs.observer.reset()
        //   item.$refs.observer.validate()
        // })
      }
      catch(e){
        this.$refs.snackbar.show('Something went wrong :(')
        console.log(e)
      }
      finally{
        this.loading = false
        this.showSaveConfirm = false
      }
    }
  },
  watch: {    
    'editorStructure.order' : async function(n, o) {
      console.log(`Order changed for item: ${this.structure.id} from ${o} to ${n}`)
      try{
        this.loading = true
        if(this.structure.id)
          await axios.post(`content/${this.structure.id}/reorder/${n}`)
      }      
      catch(e){
        this.$refs.snackbar.show('Something went wrong :(')
        console.log(e)
      }
      finally{
        this.loading = false
      }  
    }
  },
  async mounted(){
    this.editorStructure?.children?.forEach(item => {
      item.editorId = item.editorId ?? generateEditorId()
    })
    if(this.editorStructure?.structure)
      Object.assign(this.structure, this.editorStructure?.structure)
    if(this.editorStructure?.children)
      Vue.set(this.structure.segJson, 'items', _.sortBy(this.editorStructure.children.map(c => {c.structure = JSON.parse(c.structure); return c;}),'order'))
    // if(this.structure.segJson.items)
    //   this.structure.segJson.items = this.structure.segJson.items.map((i, index) => ({
    //     editorId: i.editorId ?? generateEditorId(),
    //     parentId: Number(this.editorStructure.id),
    //     order: index, // unused because in case of segment, order is embedded in the json array implicitly
    //     structure: i //getEmptyContent(type)
    //   }))
    this.structure.id = this.editorStructure.id

    // if(!this.editorStructure.id)  // newly created
    //   await this.save()

    // initial validation
    setTimeout(() => this.$refs.observer.validate(), 300)
  }
}
</script>



<style lang="scss">

.contenteditor{
  .item.segment {
    
  }
}

</style>
